import { Link, LinkProps } from '@chakra-ui/react'

export type { LinkProps }

export default Link
